import React from "react";
import "./index.css";
import close from "./../../assets/close.png";
import logo from "./../../assets/logo-pocr.png";
import Done from "./../../assets/done.png";
function Dialog(props) {
  const closeDialog = () => {
    props.closeDialog();
  };
  return (
    <div className="dialog-container">
      <div className="dialog-content">
        <div className="close-btn" onClick={closeDialog}>
          <img src={close} alt="close" />
        </div>
        <img className="logo-image" src={logo} alt="logo"/>
        <img className="done" src={Done}  alt="logo"/>

        <p className="image-received-text">{props.text}</p>
      </div>
    </div>
  );
}
export default Dialog;
